import { ca } from '@cian/analytics';

export function trackLinkReportCopy() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculatorB2BPreview',
    action: 'Copy',
    label: 'Link_to_report',
  });
}

export function trackLinkReportClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculatorB2BPreview',
    action: 'Click',
    label: 'Link_to_report',
  });
}
